import { SignIn, SignUp } from "@clerk/react";

const Wrap = ({ children, testid }) => (
  <main className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-4 py-10" data-testid={testid}>
    {children}
  </main>
);

export const SignInPage = () => (
  <Wrap testid="sign-in-page"><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></Wrap>
);

export const SignUpPage = () => (
  <Wrap testid="sign-up-page"><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></Wrap>
);
